import { styled } from '@mui/material/styles';
import OutlinedInput from '@mui/material/OutlinedInput';

export { default as MuiTextField } from '@mui/material/TextField';

export type { OutlinedInputProps as TextFieldProps } from '@mui/material/OutlinedInput';

/**
 * @summary Styles matching AXP design text field
 */
const TextField = styled(OutlinedInput)(({ theme }) => ({
  '& .MuiInputBase-input': {
    padding: '10px 12px',
    fontSize: '1rem',
    lineHeight: '1.5rem',
    minHeight: '24px',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: theme?.palette?.neutralGray6?.main ?? '#6A6E79',
  },
  '&.Mui-focused .MuiInputBase-input': {
    outline: `2px solid ${theme?.palette?.secondary?.main ?? '#252A2E'}`,
    outlineOffset: '2px',
    borderRadius: theme?.shape?.borderRadius ?? '4px',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: theme?.palette?.primary?.main ?? '#0063A3',
  },
  '&.Mui-disabled': {
    backgroundColor: theme?.palette?.neutralGray0?.main ?? '#E0E1E9',
    '.MuiOutlinedInput-notchedOutline': {
      borderColor: theme?.palette?.neutralGray3?.main ?? '#6A6E79',
    },
    '.MuiOutlinedInput-input': {
      WebkitTextFillColor: theme?.palette?.text?.primary ?? '#252A2E',
      color: theme?.palette?.text?.primary ?? '#252A2E',
    },
  },
  '&.Mui-error': {
    '.MuiOutlinedInput-notchedOutline': {
      borderWidth: '2px',
    },
  },
}));

export default TextField;
